import "./Image.css";
import nophoto from "../../../../assets/images/nophoto.png";

interface ImageProps {
  image?: string;
  alt?: string;
  width?: string;
}

export const Image = ({ image, alt, width }: ImageProps) => {
  const styles = {
    width: width || "100%",
  };

  return (
    <div className="image" style={styles}>
      <img src={image || nophoto} alt={alt} />
    </div>
  );
};
